/*eslint-disable*/export const messages=JSON.parse("{\"card.button.text\":[\"Välj\"]}");